import React, { useEffect } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import styles from "./DocumentsTab.module.scss"
import FullDataTable from "components/DataTable/FullDataTable"
import TableDefImportantDocuments from "table-defs/TableDefImportantDocuments"
import Button from "components/Button/Button"
import { loadAtteestationsAction, attestDocumentAction } from "store/actions/Actions"

const DocumentsTab = props => {
    
    const { loadAtteestationsAction, files, setShowModal, setAttestationId, isAdmin } = props;

    useEffect(() => {
        if (!files){
            loadAtteestationsAction();
        }
    }, [loadAtteestationsAction, files])

    const openDocuments = () => props.history.push("/achieve/documents")

    return (
        <div className={styles["tab-documents"]}>
            <div className={styles["header"]}>
                <h3>
                    <span title="Mouse over then click on a document to open it">Important Documents</span>
                    {/* <span className={styles["header-slash"]}>/</span> */}
                </h3>
                {/* <i>(Mouse over then click on a document to open it)</i> */}
                {isAdmin && <Button
                    onClick={openDocuments}
                    className={styles.button}
                    text="GO TO DOCUMENTS"
                    iconEnd={`fal fa-long-arrow-right ${styles["button-arrow"]}`}
                />}
            </div>
            <FullDataTable
                className="data-table-important-documents-dashboard"
                rowsData={props.files}
                definitions={TableDefImportantDocuments}
                onRowClick={function(e) {
                    if (e.currentTarget.classList.contains("col-understood")) {
                        if (this.props.rowData.requires_attest === true){
                            window.scrollTo({ top:0, behavior:"smooth" });
                            setShowModal(true);
                            return;
                        }
                    } else {
                        if (this.props.rowData['file_type'] === 'video'){
                            props.history.push(`/achieve/documents/player/${this.props.rowData.document_id}`);
                        } else {
                            props.history.push(`/achieve/documents/editor/${this.props.rowData.document_id}/view`);
                        }
                    }
                }}
                customTableProps={{
                    // selectedRows: state.selectedRows,
                    attest: (rowData) => {
                        setAttestationId(rowData.id);
                    },
                }}
            />
        </div>
    )
}


const mapStateToProps = (state) => ({
    files: state.AttestationsReducer.files,
});

const mapDispatchToProps = {
    // loadImportantDocumentsAction
    attestDocumentAction,
    loadAtteestationsAction
}

// export default DocumentsTab;

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(DocumentsTab)
)
